import { Label, TableRow, TableRowDisplayEvent, TableRowExpansionEvent } from "@mcleod/components";
import { CommentsAndReferenceNumbers } from "./CommentsAndReferenceNumbers";
import { AutogenLayoutLoadTenderExpressEdiStopGrid } from "./autogen/AutogenLayoutLoadTenderExpressEdiStopGrid";
import { StringUtil } from "@mcleod/core";

export class LoadTenderExpressEdiStopGrid extends AutogenLayoutLoadTenderExpressEdiStopGrid {
    private locStopType: String;

    tableLtxStopGridOnRowExpand(event: TableRowExpansionEvent) {
        if ((event.target as TableRow).data != null) {
            const row = (event.target as TableRow).data;
            const commentsAndRefnos = event.expandComponentParent as CommentsAndReferenceNumbers;
            commentsAndRefnos.ediStopId = row.get("id");
        }
    }

    tableLtxStopGridOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow();
        const row = (event.target as TableRow).data;
        const stopTypeComponent = tableRow.findComponentById("labelStopType") as Label;

        if (row.get("stop_type") == "PU") {
            stopTypeComponent.caption = "Pickup";
        }
        else if (row.get("stop_type") == "SO") {
            stopTypeComponent.caption = "Delivery";
        }

        const address2 = row.get("address2");
        const address2Label = (event.target as TableRow).findComponentById("labelAddress2") as Label;
        if (address2Label) {
            address2Label.visible = !StringUtil.isEmptyString(address2);
        }
    }

}
